"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityDetailsLinkedGrid = exports.EntityDetailsLinkedGridDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_value_1 = require("./entity-value");
var entity_link_value_1 = require("./entity-link-value");
var grid_1 = require("../elements/grid");
var use_entities_1 = require("../../hooks/use-entities");
var lodash_1 = require("lodash");
var cn_1 = require("../../utils/cn");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var to_array_1 = require("../../utils/to-array");
var cls = (0, cn_1.classNames)('entity-details-linked-grid');
exports.EntityDetailsLinkedGridDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LinkValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(grid_1.Grid)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  LinkValue: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), LinkValueStyles)
};
var EntityDetailsLinkedGrid = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity,
    gridProps = __rest(props, ["className", "children", "entity"]);
  var defn = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var entities = (0, use_entities_1.useEntities)();
  var items = __spreadArray(__spreadArray([], __read(props.items || []), false), __read((0, lodash_1.flatMap)(defn.extraFields || {}, function (fieldDefn, name) {
    if ((0, lodash_1.includes)(["linked", "linkedMultiple", "linkedTable"], fieldDefn.type)) {
      var linkedDefn = entities[fieldDefn.entityTypeName];
      var values = (0, to_array_1.toArray)(entity[name]);
      if (linkedDefn) {
        if ((0, lodash_1.includes)(linkedDefn.autoRoutes || [], "details")) {
          return values.map(function (value) {
            return react_1.default.createElement(My.LinkValue, {
              entity: value
            });
          });
        } else {
          return values.map(function (value) {
            return react_1.default.createElement(My.Value, {
              entity: value
            });
          });
        }
      }
    }
  })), false);
  return react_1.default.createElement(My.Container, __assign({}, gridProps, {
    items: items,
    className: cls.name(className)
  }));
};
exports.EntityDetailsLinkedGrid = EntityDetailsLinkedGrid;
exports.EntityDetailsLinkedGrid.defaultProps = exports.EntityDetailsLinkedGridDefaultProps;
exports.EntityDetailsLinkedGrid.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;